import { render, staticRenderFns } from "./OnboardingPolicy.vue?vue&type=template&id=12746ee7&scoped=true&"
import script from "./OnboardingPolicy.vue?vue&type=script&lang=js&"
export * from "./OnboardingPolicy.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingPolicy.vue?vue&type=style&index=0&id=12746ee7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12746ee7",
  null
  
)

export default component.exports